import classNames from 'classnames'

import {
  getIsGretaAIChatRowGenerating,
  getIsGretaAIChatRowNewReply,
} from '../../../GretaAIChat.utils'

import * as styles from './GretaAIChatChatListItemStatus.module.css'

function GretaAIChatChatListItemStatus({
  className,
  isFinance = false,
  status,
}) {
  const isNewReply = getIsGretaAIChatRowNewReply(status)

  return (
    <span
      className={classNames(className, {
        [styles.generating]: getIsGretaAIChatRowGenerating(status),
        [styles.newReply]: isNewReply,
        [styles.newReplyFinance]: isNewReply && isFinance,
      })}
    />
  )
}

export default GretaAIChatChatListItemStatus
